/** View 1's footer legend — the other views carry their own. */
import React from "react";

import { fmtHoursShort, lbb } from "../utils/tokens";

const Swatch: React.FC<{ color: string; label: string }> = ({ color, label }) => (
	<span style={{ display: "flex", alignItems: "center", gap: 8 }}>
		<span style={{ width: 12, height: 12, background: color, border: `1px solid ${lbb.ink}` }} />
		{label}
	</span>
);

const FooterLegend: React.FC<{ isWeek: boolean; isLine: boolean; isWeekLine?: boolean; capNow: number; capLabel: string }> = ({
	isWeek,
	capNow,
	capLabel,
}) => (
	<div
		style={{
			display: "flex",
			alignItems: "center",
			justifyContent: "space-between",
			gap: 24,
			padding: "6px 16px",
			background: lbb.alloy,
			borderTop: lbb.borderInk,
			fontFamily: lbb.fontUi,
			fontSize: 12,
			color: lbb.ink60,
			flexWrap: "wrap",
		}}
	>
		<div style={{ display: "flex", gap: 24, alignItems: "center", flexWrap: "wrap" }}>
			<Swatch color={lbb.brick} label={`over ${isWeek ? "week" : "shift"} (${capLabel})`} />
			<Swatch color={lbb.navy} label={`fair band ${fmtHoursShort(capNow - (isWeek ? 6 : 1.5))} – ${capLabel}`} />
			<Swatch color={lbb.navy20} label="under-loaded" />
		</div>
	</div>
);

export default FooterLegend;
